export const padTwo = (num) => {
  return num.toString().padStart(2, '0');
};

export const formatDateMmDdYyyy = (date) => {
  if (!date) {
    return '';
  }
  const d = new Date(date);

  return [padTwo(d.getMonth() + 1), padTwo(d.getDate()), d.getFullYear()].join('/');
};

export const getDateData = ({
  inDays = 0,
  rawData = false,
  includeMonth = true,
  includeDate = true,
  includeYear = false
}) => {
  const dateData = new Date();
  dateData.setDate(dateData.getDate() + inDays);
  const dateString = dateData?.toDateString()?.split(' ');

  const month = `${dateString[1]} `;
  const date = `${dateString[2]} `;
  const year = `${dateString[3]}`;

  const formatedDate = `
    ${includeMonth ? month : ''}
    ${includeDate ? date : ''}
    ${includeYear ? year : ''}`;

  return rawData ? dateData : formatedDate;
};



// WEBPACK FOOTER //
// ./src/utils/date-utils.js